<span class="tier-color" *ngIf="tier">{{ tier }}</span>
